import type { ComponentStyleConfig } from "@chakra-ui/theme";

export const List: ComponentStyleConfig = {
  baseStyle: {
    container: {
      padding: "0 0 0 1em",
    },
  },
  variants: {
    primary: {},
    unstyled: {
      container: {
        padding: "0",
      },
    },
  },
  defaultProps: {
    variant: "primary",
  },
};
